import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
  selector: 'app-dialog-info-settings',
  templateUrl: './dialog-info-settings.component.html',
  styleUrls: ['./dialog-info-settings.component.scss']
})
export class DialogInfoSettingsComponent {
  data: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: {icon?: string; bodyMessage?: string; breakline?: boolean; titulo: string; regras: [regra: string, descricao: string],},
  ) {
    this.data = data;
  }
}
